import React from 'react';
import { ModalsKeys, TabsOption } from 'global';
import { AccountContactDialog } from 'modules/account';
import { CustomerDetailsTabs } from 'modules/customers/types';
import { PageContainer } from 'components/shared/Page/PageContainer';
import { CardBackground } from 'components/CardBackground/CardBackground';
import { TabsContainer } from 'components/shared/TabsContainer/TabsContainer';

import {
  CustomerDetailsGeneralTab,
  CustomerDetailsDocumentsTab,
  CustomerDetailsCreditAppsTab,
  CustomerDetailsActivityHubTab,
} from './tabs';

export const CustomerDetailsPage = () => {
  const tabs: TabsOption<CustomerDetailsTabs>[] = [
    {
      label: 'General',
      value: CustomerDetailsTabs.General,
      component: <CustomerDetailsGeneralTab />,
      urlAnchor: `#${CustomerDetailsTabs.General}`,
    },
    {
      label: 'Activity Hub',
      value: CustomerDetailsTabs.ActivityHub,
      component: <CustomerDetailsActivityHubTab />,
      urlAnchor: `#${CustomerDetailsTabs.ActivityHub}`,
    },
    {
      label: 'Documents',
      value: CustomerDetailsTabs.Documents,
      component: <CustomerDetailsDocumentsTab />,
      urlAnchor: `#${CustomerDetailsTabs.Documents}`,
    },
    {
      label: 'Credit Apps',
      value: CustomerDetailsTabs.CreditApps,
      component: <CustomerDetailsCreditAppsTab />,
      urlAnchor: `#${CustomerDetailsTabs.CreditApps}`,
    },
  ];

  return (
    <PageContainer
      title="Customers Details"
      modals={{
        [ModalsKeys.AccountContactDialog]: <AccountContactDialog />,
      }}
    >
      <TabsContainer<CustomerDetailsTabs> tabs={tabs} TabsLabelWrapper={CardBackground} isSyncWithAnchor />
    </PageContainer>
  );
};
